export default "__VITE_ASSET__Bbapp30G__"